module.exports = __webpack_public_path__ + "fonts/nunito-v12-latin-ext_cyrillic-ext_cyrillic_vietnamese_latin-600italic.442ff7e2.woff2";